import { PropsWithChildren, createContext } from 'react';
import { EMPTY_STRING } from 'constants/general';
import { isPublicRoute } from 'utils/routes.util';

export const DetailsPageWrapperContext = createContext({
  page: EMPTY_STRING
});

const DetailsPageWrapper = ({
  page,
  children
}: PropsWithChildren<{ page: string }>) => {
  return (
    <div
      className={`w-full flex flex-col animate-fadeIn h-full max-h-full overflow-y-auto scrollbar-thin ${isPublicRoute() ? 'bg-secondary-50' : 'bg-transparent'} dark:bg-secondary-dark-100 dark:text-secondary-dark-900 ~p-4/8 rounded shadow dark:shadow-secondary-dark-400/30`}
    >
      <DetailsPageWrapperContext.Provider value={{ page }}>
        {children}
      </DetailsPageWrapperContext.Provider>
    </div>
  );
};

export default DetailsPageWrapper;
